<div class="container-fluid form-container  p-0 m-0 ">
  <div class="row h-100 g-0 min-vh-100">
    <div
      class="col-md-6  d-flex align-items-center justify-content-center bg-light position-relative min-vh-100 left-hero">
      <img 
      ngSrc="/assets/images/trace-image.png" 
      width="700" 
      height="600"
      priority
      alt="hero image"
      class="hero-img"
    />
    </div>
    <div class="col-md-6 col-12 form-section d-flex align-items-center position-relative">
      <div class="w-100">
        <div class="form-box mx-auto">
          <div >
            <div class="top mb-3" *ngIf="!isForgotPassword">
              <h1 class="text-brand-purple" > <b>Forgot <br> Password</b></h1>
              <h6 class="text-gray">Reset your password
              </h6>
            </div>
            <form class="position-relative" *ngIf="!isForgotPassword" [formGroup]="forgotForm">
              <div class="mb-2">
                <label for="email">Email <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input formControlName="email" appFilledInput class="form-control shadow-none rounded-12 "
                     id="email">
                     <span class="invalid-feedback" *ngIf="forgotForm.get('email')?.errors?.['serverError'] ">{{
                  forgotForm.get('email')?.errors?.['serverError']
                  }} </span>
                </div>
              </div>
              <b></b>
              <button type="submit" class="btn bg-brand-purple text-white w-100 mt-3 rounded-12  mb-4"  [disabled]="utility.hasEmptyFields(forgotForm) || loader()" (click)="sendEmail()">
                <app-spinner [loader]="loader()"></app-spinner>
                <span *ngIf="!loader()">
                Send Email
                </span>
              </button>
              <p class="text-center mt-3">
                Already have an account?
                <a href="#" class="text-brand-purple" [routerLink]="['/login']">Login</a>
              </p>
            </form>
          </div>
          @if(isForgotPassword){
           <div class="email-confirmation-message text-center mx-auto" >
            <svg width="100" height="100" viewBox="0 0 150 151" fill="none" class="mb-3" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="150" height="150" rx="40" fill="#4E3162" />
              <path
                d="M38.3568 60.116L66.3321 81.2417L66.3415 81.2494C69.4478 83.5274 71.0018 84.667 72.704 85.1073C74.2085 85.4964 75.79 85.4964 77.2946 85.1073C78.9982 84.6666 80.5569 83.5236 83.6687 81.2417L111.643 60.116M110.728 55.7163L85.0821 35.1829C81.8978 32.6334 80.3043 31.3591 78.5336 30.853C76.9712 30.4065 75.3169 30.3829 73.7427 30.7859C71.9587 31.2428 70.3319 32.4721 67.0782 34.9325L39.5913 55.7173C37.4581 57.3304 36.3928 58.1375 35.6237 59.1569C34.9425 60.0598 34.4349 61.0809 34.1256 62.1688C33.7764 63.3971 33.7764 64.7345 33.7764 67.409V95.8435C33.7764 100.974 33.7764 103.54 34.7748 105.5C35.6531 107.224 37.0535 108.624 38.7772 109.503C40.7349 110.5 43.299 110.5 48.4195 110.5H101.58C106.701 110.5 109.261 110.5 111.219 109.503C112.943 108.624 114.348 107.223 115.226 105.499C116.223 103.541 116.223 100.98 116.223 95.8591V67.1078C116.223 64.5559 116.223 63.272 115.897 62.086C115.606 61.0285 115.122 60.0318 114.478 59.1435C113.752 58.1408 112.746 57.3323 110.728 55.7163Z"
                stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h1 class="text-brand-purple" > <b> Check your Email</b></h1>
            <span class="verfication-message">We have sent a password recover instructions to your email.</span>
           <button type="submit" class="btn bg-brand-purple text-white w-100 rounded-12 mt-3 mb-4"
            [disabled]="isResetBtnDisabled()" (click)="resendEmail()" >
              Resend Email
            </button>
            <span class="verfication-message">Didn’t receive Reset password email? <span class="text-brand-purple"><b> {{buttonText()}}</b></span> </span>
          </div>
        }
        </div>
        <p class="text-center small footer-text position-absolute bottom-0 start-0 end-0 text-brand-dark-purple mb-2">
          2025 Trace.
          All rights reserved.</p>
      </div>
    </div>
  </div>
</div>